import React from 'react'
import Header from '../../Components/Header/Header'
import "./HomePage.css"

const HomePage = () => {


  return (
    <div  >
      <div className='background-image home'>
      <Header/>
      </div>
    </div>
  )
}

export default HomePage